import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';

export class Contesto extends Base {

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public indennita: boolean,
              public ruoliGenerici: number[],
              public ruoliGestore: number[],
              public ruoliManager: number[],
              public ruoliVisualizzati: number[]) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla'];
  }

  public getLabel() {
    return this.descr;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    return new TableRow(this, rowValues);
  }

  public isIstituzionale(): boolean {
    return this.sigla && this.sigla==="istituzionale";
  }

}
